// extracted by mini-css-extract-plugin
module.exports = {"container":"Counter_container__WfR1A","count":"Counter_count__Q6LdA"};